import React, { useContext } from 'react';
import { ColumnDatatable, RowSelectionAction } from '@europrocurement/flexy-datatable';
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import {
    DossierActionContext,
    DossierPrescriber,
    useDossierTable as useDefaultDossierTable,
    useDossierFilters,
    useDossierPreFilters,
} from '@europrocurement/l2d-modules';
import DossierCanal from '@europrocurement/l2d-modules/modules/Dossiers/components/liste/DossierCanal/DossierCanal';
import ActionMenu from '../views/liste/ActionMenu/ActionMenu';

const useDossierTable = () => {
    const { columns } = useDefaultDossierTable();
    const { backPreFilter } = useDossierPreFilters();
    const { backDossierFilter } = useDossierFilters();
    const filters = backDossierFilter;

    const prescriberColumn: ColumnDatatable<DossierOpenSearch> = {
        label: 'Prescripteur',
        render: ({ prescripteurLibelle }) => (
            <DossierPrescriber label={prescripteurLibelle as string} />
        ),
        isDisplayed: true,
        sortable: true,
        field: 'prescripteurLibelle',
    };
    const canalColumn: ColumnDatatable<DossierOpenSearch> = {
        label: 'Canal',
        render: (dossier) => <DossierCanal dossier={dossier} />,
        isDisplayed: true,
        sortable: true,
        field: 'canal',
        sx: {
            display: {
                xs: 'none',
                sm: 'none',
                md: 'table-cell',
                lg: 'table-cell',
                xl: 'table-cell',
            },
        },
    };
    const { triggerAction } = useContext(DossierActionContext);

    columns.push({
        label: 'Actions',
        displayLabel: false,
        render: (dossier) => <ActionMenu dossier={dossier} />,
        isDisplayed: true,
        sortable: false,
        sx: {
            display: {
                xs: 'none',
                sm: 'none',
                md: 'table-cell',
                lg: 'table-cell',
                xl: 'table-cell',
            },
        },
    });
    columns.splice(2, 0, prescriberColumn);
    columns.splice(11, 0, canalColumn);

    const rowActions: RowSelectionAction[] = [
        {
            icon: 'fa-folders',
            label: 'Déplacer dans un groupe',
            onClick: (items: Array<DossierOpenSearch>) => triggerAction('manageGroups', items),
        },
        {
            icon: 'fa-paper-plane',
            label: 'Envoyer un récapitulatif',
            onClick: (items: Array<DossierOpenSearch>) => triggerAction('export', items),
        },
    ];

    return { columns, filters, preFilters: backPreFilter, rowActions };
};

export default useDossierTable;
